import React from 'react'

import FormFactory from '../../../../components/form/form-factory'

import {
  Content, Wrapper, LogoImage, Header, Section,
} from './styles'

import logoIntro from '../../../../assets/png/logo-intro.png'
import arrowLeft from '../../../../assets/svg/arrow-left-line.svg'

import IFormPage from '../../../../interfaces/form-page'

type IProps = any &
  IFormPage & {
    handleBackClick: (evt: React.MouseEvent<HTMLButtonElement>) => void
  }

const Signin = ({
  dataForm,
  onSubmit,
  errorMessage,
  handleBackClick,
}: IProps): JSX.Element => {
  window.dataLayer.push({
    event: 'signin',
  })
  return (
    <>
      <Header>
        <button
          type="button"
          onClick={handleBackClick}
          style={{ textDecoration: 'none', background: 'none', border: 'none' }}
        >
          <img src={arrowLeft} alt="Logo" />
          Login
        </button>
      </Header>

      <Content>
        <LogoImage src={logoIntro} alt="Logo" />
        <Wrapper>
          <Section>Login</Section>
          <FormFactory
            data={dataForm}
            onSubmit={onSubmit}
            submitErrorMessage={errorMessage}
          />
        </Wrapper>
      </Content>
    </>
  )
}

export default Signin
